// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1b55ea9d","404":"a767cb23","496":"5b9f9e93"}[chunkId] + ".chunk.js";
};